import axios from 'axios';
const lib = {};
const baseUrl =
    process.env.NODE_ENV === 'production' ?
    baseConfig.baseApi :
    'http://111.6.51.99:5003';
//新闻列表
lib.appInformationList = params =>
    axios
    .get(baseUrl + '/portalJournalism/portalInformationList', params)
    .then(res => res.data);
//热点新闻
lib.hotNew = params =>
    axios
    .get(baseUrl + '/portalJournalism/portalInformationTopList', params)
    .then(res => res.data);

lib.dataDetail = params =>
    axios
    .get(baseUrl + '/portalJournalism/getInformation', params)
    .then(res => res.data);
//新闻轮播
lib.portalbanner = params =>
    axios
    .get(baseUrl + '/portalBanner/portalbanner/list', params)
    .then(res => res.data);
//党建答题排名
lib.RankingAnswers = params =>
    axios
    .get(baseUrl + '/menhuActivity/menhuactivityquestions/rankingList', params)
    .then(res => res.data);
//问卷调查、网上投票
lib.Onlinevoting = params =>
    axios
    .get(baseUrl + '/questionnaireSurvey/getQuestions', params)
    .then(res => res.data);
//问卷调查、网上投票提交
lib.votingSubmit = params =>
    axios
    .get(baseUrl + '/questionnaireSurvey/addQuestionnaireSurveyRecor', params)
    .then(res => res.data);
//留言板
lib.MessageBoard = data =>
    axios
    .post(baseUrl + '/questionnaireSurvey/addMessageFeedback', data)
    .then(res => res.data);
//意见征集
lib.SolicitationOpinions = data =>
    axios
    .post(baseUrl + '/questionnaireSurvey/clueAdd', data)
    .then(res => res.data);
//搜索
lib.searchList = params =>
    axios
    .get(baseUrl + '/portalJournalism/portalInformationList', params)
    .then(res => res.data);

lib.informationList = params =>
    axios
    .get(baseUrl + '/appJournalism/appInformationList', params)
    .then(res => res.data);

// GET /appJournalism/getAppJournalismlianjie

lib.appJournalismlianjie = params =>
    axios
    .get(baseUrl + '/appJournalism/getAppJournalismlianjie', params)
    .then(res => res.data);

// /appJournalism/getJournalismdibuxinxi
lib.journalismdibuxinxi = params =>
    axios
    .get(baseUrl + '/appJournalism/getJournalismdibuxinxi', params)
    .then(res => res.data);
lib.getAppImgs = () =>
    axios.get(baseUrl + '/img/appImages').then(res => res.data);

export default lib;


// WEBPACK FOOTER //
// ./src/api/index.js